import { createContext } from "react"

export const InlineFilterPanelContext = createContext(false)
